var map = {
	"./icon-add-2.svg": "9d13",
	"./icon-add.svg": "1190",
	"./icon-bin-2.svg": "5889",
	"./icon-bin.svg": "2f53",
	"./icon-close-2.svg": "1003",
	"./icon-close.svg": "2bc6",
	"./icon-collapse-2.svg": "8437",
	"./icon-collapse.svg": "4d53",
	"./icon-color-2.svg": "0489",
	"./icon-color.svg": "2c09",
	"./icon-copy-2.svg": "059c",
	"./icon-copy.svg": "317e",
	"./icon-edit.svg": "c425",
	"./icon-expand-2.svg": "fd22",
	"./icon-expand.svg": "d1e5",
	"./icon-palette-2.svg": "7a5c",
	"./icon-palette.svg": "c715",
	"./icon-plus-expand.svg": "013b",
	"./icon-plus.svg": "eb33",
	"./icon-search.svg": "ba80",
	"./icon-settings-2.svg": "d9df",
	"./icon-settings.svg": "96d9",
	"./icon-tidy-2.svg": "96ae",
	"./icon-tidy.svg": "6981",
	"./icon-undo-2.svg": "3f69",
	"./icon-undo.svg": "9cb8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3448";